export type IJwtIdTokenClaims = {
    siemens_gid: string;
    given_name: string;
    family_name: string;
    nickname: string;
    name: string;
    picture: string;
    updated_at: string;
    email: string;
    email_verified: string;
    iss: string;
    aud: string;
    iat: number;
    exp: number;
    sub: string;
    sid: string;
    nonce: string;
};
